import React, { useCallback, useEffect, useState } from "react";
import classNames from "classnames/bind";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import {
    EditIcon,
    DeleteIcon,
    SearchBlack,
    // SearchIcon,
} from "../../../components/Icons/Icons";
import { Alert, Button, Pagination, Loading, Toast } from "../../../components";
import { formatDateToTime, formatDDMMYY, sorterArray } from "../../../utils";
import styles from "./WareHouse.module.css";
import axiosClient from "../../../services/axiosClient";
import NameCol from "../../../components/NameCol";

const cx = classNames.bind(styles);

const CameraGroup = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [isRefresh, setIsRefresh] = useState(false);
    const [isAlert, setIsAlert] = useState(false);
    const [textSearch, setTextSearch] = useState();
    const [dataInput, setDataInput] = useState("");
    const [code, setCode] = useState();
    const ref = React.useRef(null);
    const [toggleSort, setToggleSort] = useState(false)
    const [dataTable, setDataTable] = useState()
    const [codeError, setCodeError] = useState(200)
    const [method, setMethod] = useState('')
    const [pages, setPages] = useState(1)
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false);

    const getListWareHouse = useCallback(async () => {
        setLoading(true)
        try {
            const res = await axiosClient.get("/warehouse/get-list-warehouse/", {
                params: {
                    page: currentPage,
                    size: 10,
                    isRefresh: isRefresh,
                    warehouse_name: textSearch,
                }
            })
            const total = Math.ceil(res.count / 10)
            setPages(total);
            setData(res.data);
            setLoading(false);
        } catch (error) {
            if (error?.response?.status === 403) {
                Toast.open('Không có quyền xem kho', 'danger')
                setCodeError(403)
            } else {
                Toast.open('Không tải được danh sách kho', 'danger')
            }
            setLoading(false)
        }
    }, [currentPage, isRefresh, textSearch])
    useEffect(() => {
        getListWareHouse()
    }, [getListWareHouse])
    const handleClick = (page) => {
        setCurrentPage(page);
    };
    const handleNext = () => {
        setCurrentPage(currentPage + 1);
    };
    const handlePrevious = () => {
        setCurrentPage(currentPage - 1);
    };
    const showAlert = (code) => {
        setIsAlert(true);
        setCode(code);
    };
    const onChangeTextSearch = (e) => {
        setDataInput(e.target.value);
        if (ref.current) {
            clearTimeout(ref.current);
        }
        ref.current = setTimeout(() => {
            const data = e.target.value;
            setTextSearch(data);
            setIsRefresh(!isRefresh);
        }, 300);
        setCurrentPage(1)
    };
    const handleClose = () => {
        setIsAlert(false);
    };
    const handleDeleteWareHouse = async () => {
        try {
            setIsAlert(false);
            const res = await axiosClient.delete(`/warehouse/delete-remove-warehouse/?warehouse_code=${code}`);
            if (res && res.result) {
                Toast.open("Xóa kho thành công", "success");
                navigate(0, { replace: true });
            } else {
                Toast.open("Xóa kho không thành công", "danger");
            }
        } catch (e) {
            if (e.response.status === 403) {
                Toast.open("Bạn không có quyền xóa kho", "danger")
            }
            else {
                Toast.open("Xóa kho không thành công")
            }
        }
    };

    useEffect(() => {
        const newData = data ? data : null
        if (newData && method.length > 0) {
            switch (toggleSort) {
                case 'up':
                    const dataSortUp = sorterArray(newData, method)
                    setDataTable(dataSortUp)
                    break;
                case 'down':
                    const dataSortDown = sorterArray(newData, method)
                    setDataTable(dataSortDown.reverse())
                    break;
                default:
                    setDataTable(newData)
                    break;
            }
        } else {
            setDataTable(newData)
        }
    }, [data, toggleSort, method])

    const handleSort = (type, method) => {
        if (type !== toggleSort) {
            setToggleSort(type)
            setMethod(method)
        } else {
            setToggleSort(false)
            setMethod('')
        }
    }

    const handleViewInfo = (code) => {
        navigate(`/admin/warehouse/edit_warehouse/${code}`)
    }

    return (
        <>
            {isAlert && (
                <Alert
                    type="alert"
                    title="Bạn có muốn xóa không"
                    onClose={handleClose}
                    onOk={handleDeleteWareHouse}
                />
            )}
            <div className={cx("header")}>
                <h1 className={cx("title")}>Quản trị kho</h1>
            </div>
            <div className={cx("content")}>
                <div className={cx("filter")}>
                    <div className={cx("search")}>
                        <input
                            className={cx("search-input")}
                            value={dataInput}
                            onChange={onChangeTextSearch}
                            placeholder="Tìm kiếm..."
                            maxLength={155}
                        />
                        <span className={cx("icon-search")}>
                            <SearchBlack />
                        </span>
                    </div>

                    {codeError !== 403 && (
                        <Link
                            style={{ textDecoration: "none" }}
                            to="/admin/warehouse/create_warehouse"
                        >
                            <Button className={cx("btn")} title="Thêm mới kho" onClick={() => 0} />
                        </Link>
                    )}
                </div>
                {!loading ? (
                    <>
                        <table className={cx("table")}>
                            <thead>
                                <tr>
                                    <th className={cx('number-columns', 'center')}>STT</th>
                                    <th>
                                        <NameCol active={method} title={'Tên kho'} handleSort={handleSort} method={'WAREHOUSE_NAME'} />
                                    </th>
                                    <th>
                                        <NameCol active={method} title={'Địa chỉ'} handleSort={handleSort} method={'COMMUNE_NAME'} />
                                    </th>
                                    <th>
                                        <div className={cx('number-columns', 'center')}>
                                        Số lượng camera
                                        </div>
                                    </th>
                                    <th>
                                        <NameCol active={method} title={'Người tạo'} handleSort={handleSort} method={'EDIT_USER'} />
                                    </th>
                                    <th>
                                        <NameCol active={method} title={'Ngày tạo'} handleSort={handleSort} method={'CREATE_TIME'} />
                                    </th>
                                    <th>
                                        <NameCol active={method} title={'Sửa lần cuối'} handleSort={handleSort} method={'EDIT_TIME'} />
                                    </th>
                                    <th className={cx('number-columns', 'center')}>
                                        Hành động
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataTable &&
                                    dataTable.length > 0 &&
                                    dataTable.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td onClick={() => handleViewInfo(item.CODE)}>
                                                    <div className={cx('number-columns', 'center')}>
                                                        {index + 1}
                                                    </div>
                                                </td>
                                                <td onClick={() => handleViewInfo(item.CODE)}>{item.WAREHOUSE_NAME !== 'z' ? item.WAREHOUSE_NAME : ''}</td>
                                                <td onClick={() => handleViewInfo(item.CODE)}>{item.COMMUNE_NAME} - {item.DISTRICT_NAME} - {item.PROVINCE_NAME}</td>
                                                <td onClick={() => handleViewInfo(item.CODE)}>
                                                    <div className={cx('number-columns', 'center')}>
                                                        {item.COUNT_CAM !== 'z' ? item.COUNT_CAM : ''}
                                                    </div>
                                                </td>
                                                <td onClick={() => handleViewInfo(item.CODE)}>{item.EDIT_USER}</td>
                                                <td onClick={() => handleViewInfo(item.CODE)}>
                                                    <div className={cx('number-columns')}>
                                                        {formatDDMMYY(item?.CREATE_TIME)}</div>
                                                </td>
                                                <td onClick={() => handleViewInfo(item.CODE)}>
                                                    <div className={cx('number-columns')}>
                                                        {formatDDMMYY(item?.EDIT_TIME)}</div>
                                                </td>
                                                <td>
                                                    <div className={cx('number-columns','center')}>
                                                        <button onClick={(e) => showAlert(item.CODE)}>
                                                            <DeleteIcon />
                                                        </button>

                                                        <button onClick={() => handleViewInfo(item.CODE)}>
                                                            <EditIcon />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </>
                ) : (
                    <div className={cx("loading")}>
                        <Loading />
                    </div>
                )}
                <div className={cx("pagination")}>
                    <Pagination
                        onClick={handleClick}
                        onNext={handleNext}
                        onPrevious={handlePrevious}
                        currentPage={currentPage}
                        pages={pages}
                    />
                </div>
            </div>
        </>
    );
};

export default CameraGroup;
